export interface TabSpec {
  id: string;
  label: string;
  /** A count or a mark shown on the tab (open Choices, a Session in play). */
  badge?: number | string | null;
}

interface Props {
  tabs: TabSpec[];
  active: string;
  onSelect: (id: string) => void;
}

/** The tab strip: sticky under the header, scrolls sideways if the tabs outgrow the width, each tab a 44 pt target. */
export function Tabs({ tabs, active, onSelect }: Props) {
  return (
    <nav class="tabs" role="tablist" aria-label="Sheet">
      {tabs.map((t) => (
        <button type="button" key={t.id} role="tab" aria-selected={t.id === active} class={`tab${t.id === active ? " active" : ""}`} onClick={() => onSelect(t.id)}>
          {t.label}
          {t.badge !== null && t.badge !== undefined ? <span class="badge">{t.badge}</span> : null}
        </button>
      ))}
    </nav>
  );
}
